import api from '@/api'
import Report, { UnsupportedMediaTypeReport } from '@/api/communique/report'
import types from '@/types'

//Subject to be modified as more stats are added
export interface CampaignVideoViewStats {
  imps: number | null
  pcts_25: number | null
  pcts_50: number | null
  pcts_75: number | null
  pcts_100: number | null
}

export interface queryParams {
  startDate?: string
  endDate?: string
  initiativeId?: string
  mediaTypes: string[]
  excludeLineItemIds?: string[]
  includeLineItemIds?: string
}

export class CampaignVideoViewModel {
  public async fetch({
    initiativeId,
    mediaTypes,
    startDate,
    endDate,
    excludeLineItemIds,
    includeLineItemIds,
  }: queryParams): Promise<Report<CampaignVideoViewStats> | UnsupportedMediaTypeReport> {
    return api('report.dashboards.ihmCampaign.v2.campaignVideoViewStats')
      .params({
        initiativeId: initiativeId,
        media_types: mediaTypes,
        start_date: startDate,
        end_date: endDate,
        exclude_line_item_ids: excludeLineItemIds,
        include_line_item_ids: includeLineItemIds,
      })
      .cache(1000 * types.config.dashboardCacheSeconds())
      .jsonMust<Report<CampaignVideoViewStats>>()
  }
}
